// Call recording ka chhota player: play/pause, waveform jaisi bars, samay.
// Browser ke <audio controls> ki jagah — awaaz wahi <audio> bajata hai, bas
// uske controls chhupe hain aur ye apna UI dikhata hai.
import React, { useRef, useState } from "react";
import styles from "./PounceLeads.module.css";

// Bars ki unchai (%). Asli waveform nahi — recording ko decode kiye bina sirf
// ek sa dikhne wala pattern; bajte waqt bhari hui bars progress dikhati hain.
const BARS = [30, 55, 80, 45, 100, 60, 85, 40, 70, 50, 90, 35, 65, 45, 75, 30, 55, 40, 60, 30];

const formatTime = (seconds) => {
  if (!Number.isFinite(seconds) || seconds < 0) return "0:00";
  const total = Math.floor(seconds);
  return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, "0")}`;
};

const PounceAudioPlayer = ({ src }) => {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [current, setCurrent] = useState(0);
  const [duration, setDuration] = useState(0);

  const hasDuration = Number.isFinite(duration) && duration > 0;
  const progress = hasDuration ? current / duration : 0;

  const toggle = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (audio.paused) audio.play().catch(() => setPlaying(false));
    else audio.pause();
  };

  // Bars pe tap = us jagah se bajao.
  const seek = (e) => {
    const audio = audioRef.current;
    if (!audio || !hasDuration) return;
    const box = e.currentTarget.getBoundingClientRect();
    const ratio = Math.min(1, Math.max(0, (e.clientX - box.left) / box.width));
    audio.currentTime = ratio * duration;
    setCurrent(audio.currentTime);
  };

  return (
    <div className={styles.player}>
      <audio
        ref={audioRef}
        src={src}
        preload="metadata"
        onLoadedMetadata={(e) => setDuration(e.currentTarget.duration)}
        onDurationChange={(e) => setDuration(e.currentTarget.duration)}
        onTimeUpdate={(e) => setCurrent(e.currentTarget.currentTime)}
        onPlay={() => setPlaying(true)}
        onPause={() => setPlaying(false)}
        onEnded={() => {
          setPlaying(false);
          setCurrent(0);
        }}
      />

      <button
        type="button"
        className={styles.playBtn}
        onClick={toggle}
        aria-label={playing ? "Pause recording" : "Play recording"}
      >
        {playing ? (
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <rect x="5" y="4" width="5" height="16" rx="1.5" />
            <rect x="14" y="4" width="5" height="16" rx="1.5" />
          </svg>
        ) : (
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M7 4.5v15a1 1 0 0 0 1.5.86l12.5-7.5a1 1 0 0 0 0-1.72L8.5 3.64A1 1 0 0 0 7 4.5Z" />
          </svg>
        )}
      </button>

      <div
        className={`${styles.wave} ${playing ? styles.wavePlaying : ""}`}
        onClick={seek}
        aria-hidden="true"
      >
        {BARS.map((height, i) => (
          <span
            key={i}
            className={`${styles.waveBar} ${
              // Ruka hua aur shuru me: pehli aadhi bars bhari (design jaisa).
              (current > 0 ? (i + 0.5) / BARS.length <= progress : i < BARS.length / 2)
                ? styles.waveBarOn
                : ""
            }`}
            // Har bar thodi der se shuru — lehar jaisi chaal, sab ek saath nahi.
            style={{ height: `${height}%`, animationDelay: `${(i % 5) * -0.18}s` }}
          />
        ))}
      </div>

      <span className={styles.playerTime}>
        {current > 0 || !hasDuration ? formatTime(current) : formatTime(duration)}
      </span>
    </div>
  );
};

export default PounceAudioPlayer;
